export interface IPenaltyType {
    id: number,
    name: string
}

export enum PenaltyType {
    PerDay = 1,
    PerMonth = 2
}